var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraficosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_4685)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1635 14.2794C20.1635 13.9521 19.8982 13.6868 19.5709 13.6868H15.4177C15.0905 13.6868 14.8252 13.4215 14.8252 13.0943V12.1441C14.8252 11.8168 15.0905 11.5515 15.4177 11.5515H21.7062C22.0335 11.5515 22.2988 11.8168 22.2988 12.1441V18.4325C22.2988 18.7598 22.0335 19.0251 21.7062 19.0251H20.756C20.4288 19.0251 20.1635 18.7598 20.1635 18.4325V14.2794Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8795 12.6413C22.1111 12.8725 22.1115 13.2477 21.8803 13.4793L14.9924 20.3812C14.7607 20.6133 14.3846 20.6131 14.1531 20.3808L10.5312 16.7438C10.2997 16.5114 9.92353 16.5112 9.69186 16.7434L2.96813 23.4814C2.73697 23.713 2.36179 23.7134 2.13014 23.4823L1.45752 22.8111C1.22587 22.5799 1.22548 22.2047 1.45664 21.9731L9.69338 13.7189C9.92505 13.4867 10.3012 13.4869 10.5327 13.7193L14.1547 17.3563C14.3861 17.5887 14.7623 17.5889 14.994 17.3568L20.3689 11.9709C20.6001 11.7393 20.9752 11.7389 21.2069 11.9701L21.8795 12.6413Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8265 3.58869C20.8265 3.26144 20.5613 2.99615 20.234 2.99615H16.0808C15.7536 2.99615 15.4883 2.73085 15.4883 2.4036V1.45339C15.4883 1.12613 15.7536 0.86084 16.0808 0.86084H22.3693C22.6966 0.86084 22.9619 1.12613 22.9619 1.45339V7.74187C22.9619 8.06912 22.6966 8.33441 22.3693 8.33441H21.4191C21.0918 8.33441 20.8265 8.06912 20.8265 7.74187V3.58869Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5425 1.95063C22.7742 2.1818 22.7746 2.55698 22.5434 2.78862L15.6555 9.69052C15.4238 9.92266 15.0476 9.92247 14.8162 9.69008L11.1942 6.05312C10.9628 5.82072 10.5866 5.82053 10.3549 6.05269L3.63121 12.7907C3.40005 13.0224 3.02487 13.0228 2.79322 12.7916L2.12061 12.1204C1.88896 11.8893 1.88856 11.5141 2.11972 11.2824L10.3565 3.02818C10.5881 2.79602 10.9643 2.79621 11.1958 3.0286L14.8178 6.66564C15.0492 6.89802 15.4254 6.89822 15.6571 6.66608L21.032 1.28026C21.2631 1.04862 21.6383 1.04824 21.87 1.27941L22.5425 1.95063Z",
    fill: "#143578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_4685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.380859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraficosIcon);
export default __webpack_public_path__ + "static/media/GraficosIcon.0030f4d38171f3e31af25ba9dd4285c4.svg";
export { ForwardRef as ReactComponent };